import React from "react";

import ContractHoldersHeaderGroupTypeOptions from "../HeaderGroupTypeOptions.jsx";
import HeaderGroupAdditionalOptions from "./HeaderGroupAdditionalOptions.jsx";

export default function ContractHoldersHeaderGroupOptions({ contractHoldersGroups, options, setOptions }) {
  return (
    <div id="filtergroup" className="row">
      <ContractHoldersHeaderGroupTypeOptions
        contractHoldersGroups={contractHoldersGroups}
        options={options}
        setOptions={setOptions}
      >
        <HeaderGroupAdditionalOptions options={options} setOptions={setOptions} />
      </ContractHoldersHeaderGroupTypeOptions>
    </div>
  );
}
